import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { getPersonaVehicular } from '../api/consultaVehicularApi';
import { UseAuth } from "../hooks/useAuth";
import { withRouter } from "../hooks/withRouter";



function Busqueda(props) {
  const { location } = props.router;
  const [result, setResult] = useState([])
  const { accessToken } = UseAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


 useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPersonaVehicular(accessToken, location.search);
        setResult(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accessToken, location.search]);

  if (error) {
    throw error;
  }




useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000); // Tiempo de espera en milisegundos (en este caso 3 segundos)

    return () => clearTimeout(timeout);
  }, []); // Se ejecuta solo en el montaje inicial

  if (loading) {
    return (
      <div className='padron'>
        <div className='top-bar2'>
          <div className="top-bar">
            <div className="logo">
              {/* Botón con apariencia de logo que lleva a la página principal */}
              <Link to="/">
                <button className="logo-button">
                  <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                </button>
              </Link>
            </div>
          </div>
        </div>
        <h1>Consulta Vehicular</h1>

        <div className='padron'>Buscando...</div>
      </div>
    );
  }

  if (result.length === 0) {
    return (
      <div className='padron'>
        <div className='top-bar2'>
          <div className="top-bar">
            <div className="logo">
              {/* Botón con apariencia de logo que lleva a la página principal */}
              <Link to="/">
                <button className="logo-button">
                  <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                </button>
              </Link>
            </div>
          </div>
        </div>
        <h1>Consulta Vehicular</h1>
        <div className='padron'>No hay resultados</div>
      </div>
    );
  }


  return (
    <div>

      <div className='top-bar2'>
        <div className="top-bar">

          <div className="logo">
            {/* Botón con apariencia de logo que lleva a la página principal */}
            <Link to="/">
              <button className="logo-button">
                <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className='padron'>
        <div className='results'>
          <h1>Consulta Padrones</h1>
          <div className='results-container'>
            <ul >
              {result.map((res, index) => (

                <li className="res-list"  key={index}>


                  <Link to={`/detalles/${res.id}`} >
                    <h1>{res.nombre}</h1>
                  </Link>

                </li>

              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(Busqueda);
